// extracted by mini-css-extract-plugin
export default {"infoQuestionRoot":"InfoQuestionCard_infoQuestionRoot__avEe+"};